export const CQUserType = Object.freeze({
    CLIENT: 'CLIENT',
    MANAGER: 'MANAGER',
    AUDITOR: 'AUDITOR',
    QA: 'QA', 
    ADMIN: 'ADMIN',
    REVIEWER: 'REVIEWER',
    UNDEFINED: "USER_NOT_DEFINED" 
})

